import {
  FETCH_RESTAURANTS_REQUEST,
  FETCH_RESTAURANTS_SUCCESS,
  FETCH_RESTAURANTS_FAILURE,
  FETCH_TABLES_AVAILABILITY_REQUEST,
  FETCH_TABLES_AVAILABILITY_SUCCESS,
  FETCH_TABLES_AVAILABILITY_FAILURE,
  FETCH_TABLES_WEEK_AVAILABILITY_REQUEST,
  FETCH_TABLES_WEEK_AVAILABILITY_SUCCESS,
  FETCH_TABLES_WEEK_AVAILABILITY_FAILURE,
  FETCH_TABLES_RESTAURANT_CONFIG_REQUEST,
  FETCH_TABLES_RESTAURANT_CONFIG_SUCCESS,
  FETCH_TABLES_RESTAURANT_CONFIG_FAILURE,
} from '@store/table/actions';

export const initialState = {
  isRestaurantsFetching: false,
  isAvailabilitiesFetching: false,
  isAvailabilitiesWeekFetching: false,
  isRestaurantConfigFetching: false,
  restaurants: null,
  restaurantConfig: {},
  timeSlotError: null,
  timeSlots: null,
  promotions: null,
};

export default (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case FETCH_RESTAURANTS_REQUEST:
      return {
        ...state,
        isRestaurantsFetching: true,
      };
    case FETCH_RESTAURANTS_SUCCESS: {
      return {
        ...state,
        isRestaurantsFetching: false,
        restaurants: payload.map(({ value, label, config, restaurantName }) => ({
          value,
          label,
          config,
          restaurantName,
        })),
        closedDates: payload.reduce(
          (closedDates, date) => ({
            ...closedDates,
            [date.name]: date.closedDates,
          }),
          {}
        ),
      };
    }
    case FETCH_RESTAURANTS_FAILURE:
      return {
        ...state,
        isRestaurantsFetching: false,
      };
    case FETCH_TABLES_AVAILABILITY_REQUEST:
      return {
        ...state,
        isAvailabilitiesFetching: true,
        timeSlots: [],
        promotions: [],
        timeSlotError: null,
      };
    case FETCH_TABLES_AVAILABILITY_SUCCESS:
      return {
        ...state,
        isAvailabilitiesFetching: false,
        timeSlots: payload.timeSlots,
        promotions: payload.promotions,
      };
    case FETCH_TABLES_AVAILABILITY_FAILURE:
      return {
        ...state,
        isAvailabilitiesFetching: false,
        timeSlotError: payload,
      };
    case FETCH_TABLES_WEEK_AVAILABILITY_REQUEST:
      return {
        ...state,
        isAvailabilitiesWeekFetching: true,
      };
    case FETCH_TABLES_WEEK_AVAILABILITY_SUCCESS:
      return {
        ...state,
        isAvailabilitiesWeekFetching: false,
        weekOfTimeslots: payload,
      };
    case FETCH_TABLES_WEEK_AVAILABILITY_FAILURE:
      return {
        ...state,
        isAvailabilitiesWeekFetching: false,
        weekOfTimeslots: [],
        weekOfTimeslotsError: payload,
      };
    case FETCH_TABLES_RESTAURANT_CONFIG_REQUEST:
      return {
        ...state,
        isRestaurantConfigFetching: true,
      };
    case FETCH_TABLES_RESTAURANT_CONFIG_SUCCESS:
      return {
        ...state,
        isRestaurantConfigFetching: false,
        restaurantConfig: {
          ...state.restaurantConfig,
          [payload.restaurant]: payload.config,
        },
      };
    case FETCH_TABLES_RESTAURANT_CONFIG_FAILURE:
      return {
        ...state,
        isRestaurantConfigFetching: false,
      };
    default:
      return state;
  }
};
